/* eslint-disable react/no-multi-comp */
import React, { useState, useEffect } from 'react';
import ApolloClient from 'apollo-client';
import { useQuery, QueryHookOptions } from '@apollo/react-hooks';
import GET_SEGMENT_IDENTIFY_QUERY from './SegmentIdentify';
import PromoSnackBar from '../PromoSnackBar';
import { TastingKitPromoProps } from './TastingKitSnackBar';

declare global {
  interface Window {
    analytics: any;
  }
}

type TastingKitSnackBarComponentProps = {
  apolloClient: ApolloClient<any>;
} & TastingKitPromoProps;

function TastingKitSnackBarComponent({
  apolloClient,
  user,
  config,
}: TastingKitSnackBarComponentProps) {
  const [anonymousId, setAnonymousId] = useState('');

  // load segment anonymousId after window load
  useEffect(() => {
    if (window && window.analytics) {
      if (typeof window.analytics.user !== 'function') return;
      const returnedId = window.analytics.user().anonymousId();
      setAnonymousId(returnedId);
    }
  }, []);

  const handleRouteChange = (value: string) => {
    window.location.href = value;
  };

  const queryOptions = {
    client: apolloClient,
    variables: { anonymousId, accountId: user.userId },
    skip: !user.userId && !anonymousId,
  } as QueryHookOptions;

  // query segmentIdentify for segment information
  const { data } = useQuery(GET_SEGMENT_IDENTIFY_QUERY, queryOptions);
  const segmentPersonas = data && data.viewer.segmentIdentify;
  const userRole = user && user.role;

  if (
    (segmentPersonas && segmentPersonas.prospects === true) ||
    userRole === 'anonymous'
  ) {
    return (
      <PromoSnackBar config={config} handleRouteChange={handleRouteChange} />
    );
  }
  return null;
}

export default TastingKitSnackBarComponent;
